module.exports = __webpack_public_path__ + "static/img/jiaotong-7.8cb29a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/jiaotong-7.png
// module id = IP6p
// module chunks = 1